import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";
import ReasonModal from "../ReasonModal";
import {
  AddCircle,
  ArrowDown,
  CloseCircle,
  DocumentDownload,
  Edit,
  Edit2,
  Eye,
  Mobile,
  ProfileAdd,
  ShieldTick,
  ShoppingCart,
  TickCircle,
  Trash,
} from "iconsax-react";
import moment from "moment/moment";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import CustomPagination from "../../Utils/CustomPagination";
import LogModal from "./LogModal";
import { useLoader } from "../../Loader";
import RejectModal from "./RejectModal";

function List(props) {
  const [installation, setInstallation] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState("");
  const [showLogModal, setShowLogModal] = useState(false);
  const [currentLog, setCurrentLogs] = useState([]);
  const handleShowModal = useCallback(
    (title, text) => () => {
      setModalTitle(title);
      setModalText(text);
      setShowModal(true);
    },
    []
  );
  const { startLoader, stopLoader } = useLoader();
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const userProfile = useSelector((state) => state.userProfile.userProfile);

  const permissions = [
    {
      approve: "installation.Plant_approve",
      reject: "installation.Plant_reject",
      titleA: "Plant Manager Approval",
      titleR: "Plant Manager Reject",
      status: "1",
    },
    {
      approve: "installation.ProjectManager_approve",
      reject: "installation.ProjectManager_reject",
      titleA: "Project Manager Approval",
      titleR: "Project Manager Reject",
      status: "2",
    },
    {
      approve: "installation.Finance_approve",
      reject: "installation.Finance_reject",
      titleA: "Finance Approval",
      titleR: "Finance Reject",
      status: "3",
    },
    {
      approve: "installation.CFO_approve",
      reject: "installation.CFO_reject",
      titleA: "CFO Approval",
      titleR: "CFO Reject",
      status: "4",
    },
    {
      approve: "installation.CEO_approve",
      reject: "installation.CEO_reject",
      titleA: "CEO Approval",
      titleR: "CEO Reject",
      status: "5",
    },
  ];

  const renderPermissionButtons = (row) =>
    permissions
      .filter((perm) => perm.status == row.status)
      .map((perm, index) => (
        <React.Fragment key={index}>
          {utils.hasPermission(
            primaryMenuRes,
            "Installation",
            perm.approve
          ) && (
            <RB.Button
              className="btn-flat me-1"
              title={`${perm.titleA}`}
              onClick={handleApprove(row)}
            >
              <TickCircle />
            </RB.Button>
          )}
          {utils.hasPermission(primaryMenuRes, "Installation", perm.reject) && (
            <RB.Button
              className="btn-flat me-1"
              title={`${perm.titleR}`}
              onClick={handleReject(row)}
            >
              <CloseCircle />
            </RB.Button>
          )}
        </React.Fragment>
      ));

  const columns = [
    {
      name: (
        <div>
          Installation Certificate No <br />
        </div>
      ),
      selector: (row, index) => row.installation_certificate_no,
    },
    {
      name: "Plant",
      selector: (row, index) => row.plant_name,
    },
    {
      name: "Location",
      selector: (row, index) => row.location_name,
      width: "200px",
    },
    {
      name: (
        <div>
          Equipment Name <br />
        </div>
      ),
      selector: (row, index) => row.equipment_name,
    },
    {
      name: "Asset Code",
      selector: (row, index) => row.asset_code_no,
    },
    {
      name: (
        <div>
          Installation Logs <br />
        </div>
      ),
      cell: (row) => (
        <>
          <RB.Button
            className="btn-flat me-1"
            title="View"
            onClick={handleLogView(row)}
          >
            <Eye />
          </RB.Button>
        </>
      ),
    },
    {
      name: "Status",
      selector: (row, index) => row.status_label,
      width: "210px",
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <RB.Button
            className="btn-flat ms-1 me-1"
            title="View"
            onClick={handleView(row)}
          >
            <Eye />
          </RB.Button>
          {utils.hasPermission(
            primaryMenuRes,
            "Installation",
            "installation.edit"
          ) && (
            <>
              {row.status == "1" && (
                <RB.Button
                  className="btn-flat ms-1"
                  title="Edit"
                  onClick={handelEdit(row)}
                >
                  <Edit2 />
                </RB.Button>
              )}
            </>
          )}
          {utils.hasPermission(
            primaryMenuRes,
            "Installation",
            "installation.edit_for_Finance"
          ) && (
            <>
              {row?.status == "3" && (
                <RB.Button
                  className="btn-flat ms-1 me-1"
                  title="Edit"
                  onClick={handelEdit(row)}
                >
                  <Edit2 />
                </RB.Button>
              )}
            </>
          )}
          {/* {utils.hasPermission(
            primaryMenuRes,
            "Installation",
            "installation.delete"
          ) && (
            <>
              <RB.Button
                className="btn-flat ms-1"
                title="Delete"
                onClick={showDelete(row)}
              >
                <Trash />
              </RB.Button>
            </>
          )} */}
          {renderPermissionButtons(row)}
        </>
      ),
    },
  ];

  const handleApprove = useCallback((row) => async () => {
    startLoader();
    var bodyFormData = new FormData();
    bodyFormData.append("installation_id", row.id);
    bodyFormData.append("status", "accept");
    bodyFormData.append("reject_reason", "");

    utils
      .callAPI("post", `/installation/change-status`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          getInstallation();
          stopLoader();
        } else {
          getInstallation();
          stopLoader();
        }
      })
      .catch((err) => {
        getInstallation();
        stopLoader();
      });
  });

  const handleReject = useCallback((row) => async () => {
    setSelectedOrder(row);
    setShowRejectModal(true);
  });

  const handleLogView = useCallback((row) => async () => {
    setCurrentLogs(row.install_log);
    setShowLogModal(true);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleInstallation = useCallback((row) => async () => {
    const propdata = {
      mode: "installation",
      rowData: row,
    };
    props.onChange(propdata);
  });

  useEffect(() => {
    getInstallation();
  }, [page]);

  const getInstallation = () => {
    utils
      .callAPI(
        "get",
        `/installation/list?page=${page}&per_page=${countPerPage}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setInstallation(res);
          // setFilter(false)
        } else {
          setInstallation([]);
        }
      })
      .catch((err) => {
        setInstallation([]);
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "installation",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `/installation/delete?id=${row?.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getInstallation();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow ">
          <div className="floating-btns-holder-artisan"></div>
          <RB.Card.Header>
            <h4></h4>
            <div className="card-header-action"></div>
          </RB.Card.Header>
          <RB.Card.Body>
            {utils.hasPermission(
              primaryMenuRes,
              "Installation",
              "installation.view"
            ) && (
              <>
                <DataTable
                  columns={columns}
                  data={installation.result}
                  highlightOnHover
                  responsive
                  pagination
                  paginationServer
                  paginationTotalRows={installation.total}
                  paginationPerPage={countPerPage}
                  paginationComponentOptions={{
                    noRowsPerPage: true,
                  }}
                  paginationComponent={() => (
                    <CustomPagination
                      currentPage={page}
                      totalRows={installation.total}
                      rowsPerPage={countPerPage}
                      onPageChange={handlePageChange}
                    />
                  )}
                  striped
                  onChangePage={(page) => setPage(page)}
                  persistTableHead
                  customStyles={{
                    head: {
                      style: {
                        fontSize: "0.875rem", // Adjust the font size as needed
                        fontWeight: "bold", // Adjust the font weight as needed
                      },
                    },
                  }}
                  // subHeader
                  // subHeaderComponent={subHeaderComponent}
                />
              </>
            )}
          </RB.Card.Body>
        </RB.Card>
      </div>
      <ReasonModal
        show={showModal}
        onHide={() => setShowModal(false)}
        title={modalTitle}
        text={modalText}
      />
      <LogModal
        show={showLogModal}
        onHide={() => setShowLogModal(false)}
        logs={currentLog}
      />
      <RejectModal
        show={showRejectModal}
        onHide={() => setShowRejectModal(false)}
        onReject={handleReject}
        selectedOrder={selectedOrder}
        getInstallation={getInstallation}
      />
    </>
  );
}

export default List;
